import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SnoozePicker from './SnoozePicker';

// The pipeline comes from /api/crm/meta, so a new status needs no release here.
// A status that parks a lead is sent together with the moment to ask again.
export default function StatusPicker({ statuses, comeBackStatuses, value, onMove, disabled }) {
  const { t } = useTranslation('common');
  const [parking, setParking] = useState(null);

  const pick = (status) => {
    if (comeBackStatuses.includes(status)) {
      setParking(status);
      return;
    }
    setParking(null);
    if (status !== value) onMove({ status });
  };

  return (
    <>
      <select
        className={`crm-status crm-status-${parking || value}`}
        value={parking || value}
        disabled={disabled}
        onChange={(event) => pick(event.target.value)}
        aria-label={t('crm.lead.status')}
      >
        {statuses.map((status) => (
          <option key={status} value={status}>
            {t(`crm.status.${status}`)}
          </option>
        ))}
      </select>
      {parking && (
        <div className="crm-come-back">
          <SnoozePicker
            comeBack
            withCalendar
            onPick={(when) => {
              setParking(null);
              onMove({ status: parking, next_action_at: when.toISOString() });
            }}
          />
        </div>
      )}
    </>
  );
}
